var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "control" },
    [
      [
        _c("div", { staticClass: "form-group input-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.query,
                expression: "query"
              }
            ],
            staticClass: "form-control",
            attrs: {
              id: "form-" + _vm.parent.specification,
              type: "text",
              placeholder: _vm.control.placeholder
            },
            domProps: { value: _vm.query },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.updateFilters($event)
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.query = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "input-group-append" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: {
                  type: "button",
                  disabled: !_vm.query || _vm.query.trim() === ""
                },
                on: { click: _vm.updateFilters }
              },
              [
                _c("span", { staticClass: "icon-search" }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Search")])
              ]
            ),
            _vm._v(" "),
            _vm.query && _vm.query.trim() !== ""
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-plain",
                    on: {
                      click: function($event) {
                        return _vm.clearSearch()
                      }
                    }
                  },
                  [_vm._v("\n\t\t\t\t\tClear\n\t\t\t\t")]
                )
              : _vm._e()
          ])
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }